export const TAX_ANSWER_SOURCE = {
  UNKNOWN: 0,
  INTERNAL: 1,
  EXTERNAL: 2,
  CORELOGIC: 3,
} as const;
